module.exports = __webpack_public_path__ + "static/media/thumb-ted.11119e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/articles/thumb-ted.png
// module id = 236
// module chunks = 0